export default __webpack_public_path__ + "static/media/oppa-before-modal_img.1ef77631.webp";